import React from 'react';
import { X } from 'lucide-react';
import { FormField, FieldTypeEnum } from '../../../pages/form-builder/types/formTypes';

// Interface for tooth detail props
interface ToothDetailProps {
  toothNumber: number;
  odontogramFields: FormField[];
  values: Record<string, string>;
  onValuesChange: (values: Record<string, string>) => void;
  onClose: () => void;
  onRemoveTooth: () => void;
}

export const ToothDetail: React.FC<ToothDetailProps> = ({
  toothNumber,
  odontogramFields,
  values,
  onValuesChange,
  onClose,
  onRemoveTooth
}) => {
  const handleValueChange = (fieldId: string, value: string) => {
    onValuesChange({
      ...values,
      [fieldId]: value
    });
  };

  const handleRemoveToothAndDeselect = () => {
    // Zuerst die Werte zurücksetzen
    odontogramFields.forEach((field) => {
      onValuesChange({
        ...values,
        [field.id]: ""
      });
    });
    
    onRemoveTooth();
    
    // Dann den Zahn deselektieren durch Aufruf der onClose Funktion
    onClose();
  };
  
  return (
    <div className="bg-white rounded-lg border shadow-lg p-4 w-full">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Zahn {toothNumber}</h3>
        <div className="flex gap-8">
          <button
            className="text-red-500 hover:text-red-700 border border-red-500 hover:border-red-700 rounded-md px-2"
            onClick={handleRemoveToothAndDeselect}
        >
          Auswahl aufheben
        </button>
        <button
          className="text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <X className="h-5 w-5" />
        </button>
        </div>
      </div>

      {odontogramFields.length > 0 ? (
        <div className="space-y-4">
          {odontogramFields.map(field => (
            <div key={field.id} className="space-y-1">
              <label className="text-sm font-medium">{field.label}</label>
              
              {field.type === FieldTypeEnum.SELECT && (
                <select
                  className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  value={values[field.id] || ''}
                  onChange={(e) => handleValueChange(field.id, e.target.value)}
                >
                  <option value="">Bitte wählen...</option>
                  {field.options && field.options.map((option, index) => (
                    <option key={index} value={index.toString()}>
                      {option}
                    </option>
                  ))}
                </select>
              )}
              
              {field.type === FieldTypeEnum.TEXT && (
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  value={values[field.id] || ''}
                  placeholder={field.placeholder || ''}
                  onChange={(e) => handleValueChange(field.id, e.target.value)}
                />
              )}

              {field.type === FieldTypeEnum.TEXTAREA && (
                <textarea
                  className="w-full border border-gray-300 rounded-md p-2 text-sm"
                  value={values[field.id] || ''}
                  placeholder={field.placeholder || ''}
                  rows={3}
                  onChange={(e) => handleValueChange(field.id, e.target.value)}
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-500 py-2">
          Keine zusätzlichen Felder konfiguriert.
        </div>
      )}
    </div>
  );
};